import $ from 'jquery';
import __ from './modules/i18nt';

export function init() {
  $('body').on('click', '.accommodationlist .show-more-link', function () {

    var self = $(this);
    var item = self.closest('.accommodationlist-item');
    item.toggleClass("is-extended");

    if (item.is(".is-extended")) {
      item.find('.item-show-more').show();
      item.find('.item-facts').hide();
      self.text(__('view less'));
    } else {
      item.find('.item-show-more').hide();
      item.find('.item-facts').show();
      self.text(__('view more'));
    }
  });
}